<template>
  <span class="rb-loader"></span>
</template>
<script>
/**
 * Small widget w/spinning wheel
 */
export default {};
</script>
